module.exports = __webpack_public_path__ + "img/backArticle.c1e7b166.svg";